<template>
  <b-overlay
    :show="mostrarLoader"
    opacity="0.50"
    rounded="sm"
    spinner-variant="primary"
    spinner-type="grow"
  >
    <b-card>
      <b-row class="mt-2">
        <b-col
          sm="12"
          md="6"
          lg="6"
        >
          <b-form-group>
            <label class="text-sm">Estado</label>
            <b-form-select v-model="persona.estado">
              <b-form-select-option
                v-for="item in persona_choice.estado"
                :key="item.id"
                :label="item.text"
                :value="item.value">
                {{ item.text }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group>
            <label class="text-sm">Tipo</label>
            <b-form-select v-model="persona.tipo">
              <b-form-select-option
                v-for="item in persona_choice.tipo"
                :key="item.id"
                :label="item.text"
                :value="item.value"
              >
                {{ item.text }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group :style="personaNaturalStyles">
            <label class="text-sm"><span class="text-danger">*</span> Cédula</label>
            <b-input :danger="errors.has('cedula') || input_prop.cedula.danger"  label="Cédula" v-model="persona.cedula" v-validate="`${persona.tipo==='N' ? 'required|max:10' : ''}`" class="w-full required" id="lacedula"  name="cedula" data-vv-as="cédula" placeholder="Ingrese número de cédula" maxlength="10" :class="[{'is-invalid': errors.has('cedula') || input_prop.cedula.danger}]"/>
            <span class="text-danger text-sm" v-show="errors.has('cedula')">{{  errors.first('cedula') }}</span>
            <span class="text-danger text-sm" v-show="input_prop.cedula.danger">{{  input_prop.cedula.dangertext }}</span>
          </b-form-group>

          <b-form-group :style="personaJuridicaStyles">
            <label class="text-sm"><span class="text-danger">*</span> RUC</label>
            <b-input :danger="errors.has('ruc') || input_prop.ruc.danger"  label="RUC" v-model="persona.ruc" v-validate="`${persona.tipo==='J' ? 'required|max:13|min:13' : ''}`" class="w-full required" name="ruc" data-vv-as="RUC" placeholder="Ingrese número de RUC" maxlength="13" :class="[{'is-invalid': errors.has('ruc') || input_prop.ruc.danger}]"/>
            <span class="text-danger text-sm" v-show="errors.has('ruc')" >{{  errors.first('ruc') }}</span>
            <span class="text-danger text-sm" v-show="input_prop.ruc.danger">{{  input_prop.ruc.dangertext }}</span>
          </b-form-group>

          <b-form-group>
            <label v-if="persona.tipo==='N'" class="text-sm"><span class="text-danger">*</span> Nombres de la persona</label>
            <label v-if="persona.tipo==='J'" class="text-sm"><span class="text-danger">*</span> Razón Social</label>
            <b-input :danger="errors.has('razon_social')" label="Razón Social" v-model="persona.razon_social" v-validate="'required|max:200'" class="w-full required" name="razon_social" data-vv-as="razón social" placeholder="Ingrese nombres/razón social" maxlength="200" :class="[{'is-invalid': errors.has('razon_social')}]"/>
            <span class="text-danger text-sm" v-show="errors.has('razon_social')">{{  errors.first('razon_social') }}</span>
          </b-form-group>
        </b-col>

        <b-col
          sm="12"
          md="6"
          lg="6"
        >
          <b-form-group>
            <label class="text-sm"><span class="text-danger">*</span> Email</label>
            <b-input :danger="errors.has('email')" label="Email" v-model="persona.email" v-validate="'required|email|max:100'" class="w-full required" name="email" placeholder="Ingrese correo electrónico" maxlength="100" :class="[{'is-invalid': errors.has('email')}]"/>
            <span class="text-danger text-sm" v-show="errors.has('email')">{{  errors.first('email') }}</span>
          </b-form-group>

          <b-form-group :style="personaJuridicaStyles">
            <label class="text-sm"><span class="text-danger">*</span> Nombre Comercial</label>
            <b-input :danger="errors.has('nombre_comercial')" label="Nombre Comercial" v-model="persona.nombre_comercial" v-validate="`${persona.tipo==='J' ? 'required|max:200' : ''}`" class="required w-full" name="nombre_comercial" data-vv-as="nombre comercial" placeholder="Ingrese nombre comercial" maxlength="200" style="" :class="[{'is-invalid': errors.has('nombre_comercial')}]"/>
            <span class="text-danger text-sm" v-show="errors.has('nombre_comercial')">{{  errors.first('nombre_comercial') }}</span>
          </b-form-group>

          <b-form-group :style="personaNaturalStyles">
            <label class="text-sm">RUC</label>
            <b-input :danger="errors.has('ruc') || input_prop.ruc.danger" label="RUC" v-model="persona.ruc" v-validate="`${persona.tipo==='N' ? 'max:13' : ''}`" class="w-full" name="ruc" data-vv-as="RUC" placeholder="Ingrese número de RUC" maxlength="13" :class="[{'is-invalid': input_prop.ruc.danger}]"/>
            <span class="text-danger text-sm">{{  errors.first('ruc') }}</span>
            <span class="text-danger text-sm" v-show="input_prop.ruc.danger">{{  input_prop.ruc.dangertext }}</span>
          </b-form-group>

          <b-form-group>
            <label class="text-sm">Convencional</label>
            <vue-tel-input v-model="persona.convencional" v-bind="bindProps">
              <template v-slot:arrow-icon>
                  <span>{{ open ? '▲' : '▼' }}</span>
              </template>
            </vue-tel-input>
            <!-- <b-input :danger="errors.has('convencional')" label="Convencional" v-model="persona.convencional" v-validate="'max:100'" class="w-full" name="convencional" placeholder="Ingrese número telefónico" maxlength="100"/> -->
            <span class="text-danger text-sm" v-show="errors.has('convencional')">{{  errors.first('convencional') }}</span>
          </b-form-group>

          <b-form-group>
<!--            <div class="">-->
<!--                <label for="" class="vs-input&#45;&#45;label">Celular</label>-->
<!--                <vue-tel-input v-model="persona.celular" v-bind="bindProps">-->
<!--                    <template v-slot:arrow-icon>-->
<!--                        <span>{{ open ? '▲' : '▼' }}</span>-->
<!--                    </template>-->
<!--                </vue-tel-input>-->
<!--                <span class="text-danger text-sm" v-show="errors.has('celular')">{{  errors.first('celular') }}</span>-->
<!--            </div>-->
            <label class="text-sm">Celular</label>
            <vue-tel-input v-model="persona.celular" v-bind="bindProps">
              <template v-slot:arrow-icon>
                  <span>{{ open ? '▲' : '▼' }}</span>
              </template>
            </vue-tel-input>
            <!-- <b-input :danger="errors.has('celular')" label="Celular" v-model="persona.celular" v-validate="'max:100'" class=" mt-6 w-full" name="celular" placeholder="Ingrese número de celular" maxlength="100"/> -->
            <span class="text-danger text-sm" v-show="errors.has('celular')">{{  errors.first('celular') }}</span>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <label class="text-sm">Dirección</label>
          <b-input :danger="errors.has('direccion')" label="Dirección" v-model="persona.direccion" v-validate="'max:300'" class="w-full" name="direccion" data-vv-as="dirección" placeholder="Ingrese la dirección..." maxlength="300"/>
          <span class="text-danger text-sm" v-show="errors.has('direccion')">{{  errors.first('direccion') }}</span>
        </b-col>
      </b-row>

      <b-button v-if="estaEnModoEdicion" :disabled="bloqueo_boton" id="button-with-loading" variant="primary" type="filled" class="mt-1 vs-con-loading__container" v-on:click="submitFormPersona">Guardar</b-button>
      <b-button v-else :disabled="bloqueo_boton" id="button-with-loading" variant="primary" type="filled" class="mt-1 vs-con-loading__container" v-on:click="submitFormPersona">Registrar</b-button>
    </b-card>
  </b-overlay>
</template>

<script>
import axios from '@/axios';

import { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es'
import _color from "@/assets/utils/color";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
Validator.localize("es", es);

export default {
    data() {
        return {
            persona: {
                cedula: '',
                razon_social: '',
                nombre_comercial:'',
                ruc: '',
                email:'',
                celular:'',
                convencional:'',
                direccion:'',
                estado:'A',
                tipo:'N',
            },
            persona_choice:{
                tipo:[
                      {id: 1, text: 'Natural', value:'N'},
                      {id: 2, text: 'Jurídica', value:'J'}
                     ],
                estado:[
                     {id: 3, text: 'Activo', value:'A'},
                     {id: 4, text: 'Inactivo', value:'I'},
                ],
            },
            submitted: false,
            input_prop: {
                cedula:             {danger: false, dangertext: ''},
                razon_social:       {danger: false, dangertext: ''},
                nombre_comercial:   {danger: false, dangertext: ''},
                ruc:                {danger: false, dangertext: ''},
                email:              {danger: false, dangertext: ''},
                celular:            {danger: false, dangertext: ''},
                convencional:       {danger: false, dangertext: ''},
                direccion:          {danger: false, dangertext: ''},
                empresa:            {danger: false, dangertext: ''},
            },
            mostrarLoader: false,
            bloqueo_boton: false,
            numkey: 1,

            bindProps: {
                mode: "international",
                autoformat: true,
                dropdownOptions: {
                    showDialCode: false,
                    showDialCodeInList: true,
                    showDialCodeInSelection: true,
                    showFlags: true,
                    showSearchBox: true
                },
                inputOptions: {
                    placeholder: 'Ingrese un número telefónico'
                },
                defaultCountry: 'EC'
            },
        }
    },
    methods: {
        submitFormPersona(){
            this.openLoadingInDiv()
            this.$validator.validateAll().then(result => {
                if (result) {
                  this.verificarCedulaRucExistente()
                } else {
                  this.closeLoadingInDiv();
                }
            });
        },

        create: function (e) {
                this.openLoadingInDiv()
                axios.post('api/persona/',
                        this.persona
                    )
                    .then(response => {
                        this.cleanErrors();
                        this.closeLoadingInDiv()
                        this.$router.push({name: 'personaEditar', params: { token_publico: response.data.token }})
                    })
                    .catch(error => {
                        this.cleanErrors();
                        var errores=error.response.data;
                        for(error in errores){
                            this.input_prop[error].danger = true;
                            this.input_prop[error].dangertext = errores[error][0];
                        }
                        this.closeLoadingInDiv()
                    });
        },
        openLoadingInDiv(){
            this.bloqueo_boton = true
            this.mostrarLoader = true
        },
        closeLoadingInDiv(){
            this.mostrarLoader = false
            this.bloqueo_boton = false
        },
        cleanErrors(){
            for (var key in this.input_prop) {
                this.input_prop[key].danger = false;
                this.input_prop[key].dangertext = '';
            }
        },

        update: function (e) {
                this.openLoadingInDiv()
                axios.put(`api/persona/${this.$route.params.token_publico}/`,
                        this.persona
                    )
                    .then(response => {
                        //this.$router.push('/persona/consultar');
                        this.cleanErrors()
                        this.closeLoadingInDiv()
                        this.showToast()
                    })
                    .catch(error => {
                        this.cleanErrors();
                        var errores=error.response.data;
                        for(error in errores){
                            this.input_prop[error].danger = true;
                            this.input_prop[error].dangertext = errores[error][0];
                        }
                        // this.$errores_no_controlados(error)
                        this.closeLoadingInDiv()
                    });
        },
        showToast() {
          this.$toast.success({
            component: ToastificationContent,
            props: {
              title: 'Persona',
              icon: 'SaveIcon',
              text: 'Cambios Guardados correctamente',
            },
          },
          {
            position: 'bottom-right',
          })
        },
        verificarCedulaRucExistente(){
            this.openLoadingInDiv()
            axios.post('api/persona/verificar-cedula-ruc/',{
                cedula: this.persona.cedula,
                ruc: this.persona.ruc,
                token: this.$route.params.token_publico
            })
            .then(response => {
                if ( "error"== response.data.status ){
                    this.$swal({
                      title: 'Error!',
                      text: response.data.message,
                      icon: 'error',
                      customClass: {
                        confirmButton: 'btn btn-primary',
                      },
                      buttonsStyling: false,
                      confirmButtonText: 'Aceptar',
                    })
                }else {
                    var errores = response.data.data
                    for (const [key, value] of Object.entries(errores)) {
                        this.input_prop[key].danger = true;
                        this.input_prop[key].dangertext = errores[key][0];
                    }
                    if(Object.keys(response.data.data).length === 0){
                        // if form have no errors
                        if (this.estaEnModoEdicion){
                          this.update()
                        }
                        else{
                          this.create()
                        }
                    }
                }
                this.closeLoadingInDiv()
            })
        }
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
          if(from.name=="personaRegistrar"){
            vm.showToast();
          }
          else{
            vm.persona = {
                cedula: '',
                razon_social: '',
                nombre_comercial:'',
                ruc: '',
                email:'',
                celular:'',
                convencional:'',
                direccion:'',
                estado:'A',
                tipo:'N',
            }
          }
      });
    },
    mounted() {
      if(this.estaEnModoEdicion){
        this.openLoadingInDiv()
        this.cleanErrors()
        axios.get('api/persona/' + this.$route.params.token_publico)
            .then( response => {
                this.persona = response.data
                this.closeLoadingInDiv()
            });
      }
    },
    computed:{
        personaNaturalStyles () {
            return this.persona.tipo === 'N' ? 'display: block;' : 'display: none;'
        },
        personaJuridicaStyles () {
            return this.persona.tipo === 'J' ? 'display: block;' : 'display: none;'
        },
      estaEnModoEdicion(){
        if (this.$route.params.token_publico){
          return true
        }
        else{
          return false
        }
      }
    }
}
</script>

<style>
  .required > .vs-input--label::before{
    content: "* ";
    color: #F56C6C;
  }
</style>
